import { apiClient } from '@/lib/api';
import type {
  Area,
  AreasQuery,
  AreasResponse,
  CreateAreaBody,
  CreateRegionBody,
  Region,
  UpdateAreaBody,
  UpdateRegionBody,
} from '@skewb-works/contracts';

const BASE = '/works-lite/locations';

export const locationsService = {
  // Regions
  listRegions(): Promise<Region[]> {
    return apiClient.get<Region[]>(`${BASE}/regions`);
  },
  createRegion(data: CreateRegionBody): Promise<Region> {
    return apiClient.post<Region>(`${BASE}/regions`, data);
  },
  updateRegion(id: number, data: UpdateRegionBody): Promise<Region> {
    return apiClient.put<Region>(`${BASE}/regions/${id}`, data);
  },
  deleteRegion(id: number): Promise<{ success: boolean }> {
    return apiClient.delete<{ success: boolean }>(`${BASE}/regions/${id}`);
  },

  // Areas
  listAreas(query: AreasQuery = {}): Promise<AreasResponse> {
    const params = new URLSearchParams();
    if (query.search) params.set('search', query.search);
    if (query.limit != null) params.set('limit', String(query.limit));
    if (query.skip != null) params.set('skip', String(query.skip));
    const qs = params.toString();
    return apiClient.get<AreasResponse>(`${BASE}/areas${qs ? `?${qs}` : ''}`);
  },
  createArea(data: CreateAreaBody): Promise<Area> {
    return apiClient.post<Area>(`${BASE}/areas`, data);
  },
  updateArea(id: number, data: UpdateAreaBody): Promise<Area> {
    return apiClient.put<Area>(`${BASE}/areas/${id}`, data);
  },
  deleteArea(id: number): Promise<{ success: boolean }> {
    return apiClient.delete<{ success: boolean }>(`${BASE}/areas/${id}`);
  },
};
